import React, { useState, useContext, useEffect } from 'react';
import MainTitle from 'components/MainTitle';
import FormContainer from 'components/FormContainer';
import Fieldset from 'components/Fieldset';
import Legend from 'components/Legend';
import InputControl from 'components/InputControl';
import FormActions from 'components/FormActions';
import Button from 'components/Button';
import Input from 'components/Input';
import Timer from 'components/Timer';
import { store } from '../../store.js';
import { ReSendToken } from 'core/api/loginNumbers/LoginNumbersApi';
import Modal from 'components/Modal';
import Analytics from 'core/Utils/Analytics';
import { Text } from 'mondrian-react';

const GenericTokenValidate = ({
  service,
  resendService,
  title,
  setForm,
  formData,
  navigation,
  setIsLoading,
}) => {
  const { next } = navigation;
  const [token, setToken] = useState('');
  const [isDisabled, setDisabled] = useState(true);
  const [validForm, setValidForm] = useState(false);

  const logoutLink = process.env.REACT_APP_PING_AUTHORIZE;

  const globalState = useContext(store);
  const { state, dispatch } = globalState;

  const userEmailText = state.emailData?.changeEmail;

  const [modalContent, setModalContent] = useState(null);

  const { accesstoken = 'undefined', user = {}, analytics = {} } = state;
  const {
    userToken = {},
    userData = '',
    selectedMsisdnText,
    selectedMsisdn,
  } = user;
  const { currentFlow } = analytics;
  useEffect(function () {
    Analytics().setVirtualPageView(`/meuperfil/${currentFlow}/validar-token`);
  }, []);
  async function handleSubmit(e) {
    e.preventDefault();

    setIsLoading(true);
    const submitFormData = {
      userData,
      token,
    };
    let result = await service(submitFormData, accesstoken);
    setIsLoading(false);

    let { error = null } = result;
    if (error != null) {
      const { message } = error.warning;
      setModalContent(error);

      Analytics().setErrorEvent({
        eventAction: `callback:${currentFlow}`,
        eventLabel: message,
        code: error?.errorCode
      });
      if (result.code === 401) {
        setTimeout(function () {
          window.location.href = logoutLink;
        }, 2000);
      }
    } else {
      Analytics().setSuccesEvent({
        eventAction: `callback:${currentFlow}`,
      });

      next();
    }
  }

  function tokenValidate(value) {
    setToken(value);
    if (value.length === 6) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
  }

  async function resendtoken() {
    setDisabled(true);
    setIsLoading(true);
    let submitData = {
      userData,
    };
    let result = await ReSendToken(submitData, accesstoken);
    let { error = null, userData: resendUserData } = result;

    if (error != null) {
      const { message } = error.warning;
      setModalContent(error);

      Analytics().setErrorEvent({
        eventAction: `callback:${currentFlow}`,
        eventLabel: message,
        code: error?.errorCode
      });
    } else {
      dispatch({
        type: 'SET_USER_DATA',
        payload: { userData: resendUserData },
      });
    }
    setIsLoading(false);
  }
  function onRequestClose(data = {}) {
    setModalContent(null);
  }
  return (
    <>
      {modalContent && (
        <Modal onClose={onRequestClose} content={modalContent} />
      )}
      <FormContainer onSubmit={handleSubmit}>
        <MainTitle sm>{title}</MainTitle>
        <Legend>
          <Text>
            Estamos quase terminando. Enviamos um código de verificação para
            {' ' + userToken.value}. Insira no campo abaixo:
          </Text>
        </Legend>
        <Fieldset>
          <InputControl>
            <Input
              tabIndex="20"
              label="Codigo de Verificação"
              name="inputToken"
              id="inputToken"
              mask={'999999'}
              type="text"
              maskChar=""
              onChange={(e) => tokenValidate(e.target.value)}
            />
          </InputControl>
          <FormActions>
            <Button tabIndex="21" type="submit" block disabled={!validForm}>
              Confirmar
            </Button>
            <Button
              lg
              tabIndex="22"
              type="button"
              disabled={isDisabled}
              onClick={resendtoken}
              secondary
              block
            >
              Reenviar código de verificação
            </Button>
            {isDisabled && (
              <Timer
                timer={30}
                callback={() => setDisabled(false)}
                text="Aguarde %timer% segundos para reenviar o código"
              />
            )}
          </FormActions>
        </Fieldset>
      </FormContainer>
    </>
  );
};

export default GenericTokenValidate;
